import ExitSearchAndFilterModeButton from './ExitSearchAndFilterModeButton';
import { useExitSearchAndFilterMode } from '../hooks/useExitSearchAndFilterMode';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'conv... Remove this comment to see the full error message
import { getClickedExitSearch } from 'conversations-inbox-lib/usage-tracking/inboxInteractionEvents';
import { jsx as _jsx } from "react/jsx-runtime";
const InboxExitSearchAndFilterMode = () => {
  const {
    onExitSearchAndFilterMode
  } = useExitSearchAndFilterMode();
  const handleExitSearchAndFilterMode = () => {
    onExitSearchAndFilterMode();
    trackEvent(getClickedExitSearch());
  };
  return /*#__PURE__*/_jsx(ExitSearchAndFilterModeButton, {
    exitHandler: handleExitSearchAndFilterMode
  });
};
InboxExitSearchAndFilterMode.displayName = 'InboxExitSearchAndFilterMode';
export default InboxExitSearchAndFilterMode;